export default __webpack_public_path__ + "static/slide-1-388024a25a4cfffa6cf30e029179590c.jpg";